import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { AsbestosRadiologicalProgressionChartComponent } from './asbestos-radiological-progression-chart.component';
import { FormsModule } from '@angular/forms';
import { KIconModule } from 'ng-k-icon';
import { KButtonModule } from 'ng-k-button';
import { KNotificationsModule } from 'ng-k-notifications';


@NgModule({
  declarations: [
    AsbestosRadiologicalProgressionChartComponent
  ],
  imports: [
    CommonModule,
    NgChartsModule,
    FormsModule,
    KIconModule,
    KButtonModule,
    KNotificationsModule,
  ],
  exports: [
    AsbestosRadiologicalProgressionChartComponent,
  ]
})
export class AsbestosRadiologicalProgressionChartModule { }
